import React, { useEffect, useState } from 'react'
import Styles from '../Config/Styles'
import { Typography, Box, Grid2, Divider } from '@mui/material';
import Input from './Input';
import ButtonBox from './Button';
import { sendotp } from '../Redux/Login/action';
import { useDispatch } from 'react-redux';

const Phonenumber = ({ width, setComponent, setLoading }) => {
    const dispatch = useDispatch()
    const [value, setValue] = useState('')

    useEffect(() => {
    }, [value])


    const handleClick = () => {
        setLoading(true)
        dispatch(sendotp({ phone: value }, setComponent, setLoading))
    }



    return (
        <Box sx={Styles.middleBoxStyle(width).box}>
            <Typography variant='h3' sx={{...Styles.middleBoxStyle(width).heading,fontSize:{xs:"35px",md:'42px'} }}> WELCOME! </Typography>
            <Typography variant='h6' sx={Styles.middleBoxStyle(width).heading}>Please Enter Your Mobile Number</Typography>
            <Divider sx={Styles.middleBoxStyle(width).divider} />
            <Box sx={Styles.middleBoxStyle(width).box1}>
                <Typography variant="h6">
                    Mobile Number
                </Typography>
                <Grid2 container spacing={2} >
                    <Grid2 item xs={12} sx={Styles.middleBoxStyle(width).grid}>
                        <Input placeholder={"Number"} type={"number"} startAdornment={"+966"} value={value} setValue={setValue} />
                    </Grid2>
                    <Grid2 item xs={12} sx={Styles.middleBoxStyle(width).grid}>
                        <ButtonBox text={"Send Code via WhatsApp"} onClick={handleClick} type={"phone"} color={"black"} disabled={value === '' ? true : false} min={10} />
                    </Grid2>
                </Grid2>
            </Box>
        </Box>
    )
}

export default Phonenumber